import sacRentree from '../img/sac-rentree.png';

function StartPage (props) {
	const start  = ()=>{
		props.setStep(1);
	};
	return <div className="start">
          <div className="head">
            <div className="title"> <span>Les P'tits Simulateurs</span> </div>
            <div className="main">
              <div className="img-left">
              </div>
              <div className="content">
                 <p className="question questiontitle">Ai-je droit<br/>&agrave; l'<span className="yellow">Allocation <br/>de Rentr&eacute;e Scolaire</span> ?</p>
        <img src={sacRentree} className="mobile-only"/>
                 <p className="cta-txt">Un vrai jeu d'enfant !</p>
                 <p className="txt">R&eacute;pondez &agrave; deux questions et vous saurez si<br/> vous pouvez en bénéficier</p>
                 <div className="button-container">
                   <button className="start-btn" onClick={start}>C'est parti</button>
                    </div>
                 <div className="clear clearfix"></div>
                 
              </div>
            </div>
          </div>
        </div>;
}

export default StartPage;